import { render, staticRenderFns } from "./nshop-viewer-statistics-search.vue?vue&type=template&id=63a80975&scoped=true&"
import script from "./nshop-viewer-statistics-search.vue?vue&type=script&lang=js&"
export * from "./nshop-viewer-statistics-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a80975",
  null
  
)

export default component.exports